import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const contactApi = createApi({
  reducerPath: "contactApi",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_SERVER_URL,
  }),
  endpoints: (builder) => ({
    blockListenersList: builder.query({
      query: ({ page = 1, limit = 10, search }) => ({
        url: `/user/block/listener-list`,
        method: "GET",
        params: { page, limit, search },
      }),
    }),
    unblockListener: builder.mutation({
      query: (data) => ({
        url: `/user/listener/unblock`,
        method: "DELETE",
        body: data,
      }),
    }),
    blockUsersList: builder.query({
        query: ({ page = 1, limit = 10, search }) => ({
          url: `/listener/block/user-list`,
          method: "GET",
          params: { page, limit, search },
        }),
      }),
      unblockUser: builder.mutation({
        query: (data) => ({
          url: `/listener/user/unblock`,
          method: "DELETE",
          body: data,
        }),
      }),
  }),
});

export const { useBlockListenersListQuery,useUnblockListenerMutation,useBlockUsersListQuery,useUnblockUserMutation } = contactApi;
